module.exports = __webpack_public_path__ + "static/img/2.1fc8075.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/5/8/1/sp/2.png
// module id = AswN
// module chunks = 0